export default function TestimonialOne(){
    return(
        <section className="testimonial-area pt-110 pb-90 pt-md-5 pb-md-30 pt-xs-60 pb-xs-30">
		<div className="container">
			<div className="row align-items-center">
				<div className="col-lg-6">
					<div className="testimonial-img-wrapper mb-30">
						<img className="pattern" src="assets/img/testimonial/pattern-1.png" alt="Pattern" />
						<img className="images one" src="assets/img/testimonial/t-1a.jpg" alt="T-img" />
						<img className="images two" src="assets/img/testimonial/t-1b.jpg" alt="T-img" />
						<img className="images three" src="assets/img/testimonial/t-1c.jpg" alt="T-img" />
						<img className="images four" src="assets/img/testimonial/t-1d.jpg" alt="T-img" />
						<span className="images five"><img src="assets/img/testimonial/review-1.png" alt="T-icon" /></span>
					</div>
				</div>
				<div className="col-lg-6">
					<div className="testimonial-text-wrapper mb-30 pl-30 pl-lg-0 pl-md-0 pl-xs-0">
						<div className="section-title mb-30">
							<h2 className="style-text">Review</h2>
							<h6 className="semi-title title-line">Testimonials</h6>
							<h2 className="sect-title">Refreshing your brand and paving</h2>
						</div>
						<p className="paragraph-title mb-45">We help our clients succeed by creating brand identities,
							digital IT experiences, and print materials. Helping our clients reach their full
							potential on the market.</p>
						<div className="quote-paragraph mt-0 mb-0">
							<div className="author">
								<img src="assets/img/testimonial/author.jpg" alt="Author" />
							</div>
							<div className="quote-text">
								<p className="paragraph-title">“ Professional & modern, a theme designed
									to help your business stand out from the rest.
									For marketing firms. ”.</p>
								<h6>Alonso W. William <span>-Head Of Idea </span></h6>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
    )
}